<template>
  <div>
    <div>
      <mdb-card class="mb-4">
        <mdb-card-header v-if="group.brand && group.brand.groupName && group.id != group.brand.globalId">
          <b>{{ $t("page.groupHome.localInPerson") }}</b> <br/>
          <router-link :to="group.brand.vanityPath">{{ $t("page.groupHome.clickForOnline") }}</router-link>
        </mdb-card-header>
        <mdb-card-header v-if="!group.brand || !group.brand.groupName || group.brand.globalId == group.id">
          {{ capitalize($tc("common.label.event",2)) }}
        </mdb-card-header>
        <mdb-card-body v-if="error">
          <error :error="error"/>
        </mdb-card-body>
        <mdb-card-body v-if="eventData">
          <div class="text-info small text-center" v-if="eventData.completed > 0">
            {{$t("page.groupHome.eventHistoryText", {group: group.name, hostedEvents: eventData.completed, plannedEvents: eventData.planned})}}
          </div>
          <mdb-tabs :active="0" :links="[ {text: capitalize($t('common.label.planned'))}, {text:capitalize($t('common.label.completed'))}]" :transition-duration="0.5" card
                    class="mb-2"
                    tabs
                    transition-style="linear"
          >

            <event-list :listData="eventData.events" :slot="capitalize($t('common.label.planned'))"/>
            <event-list :listData="eventData.past" :slot="capitalize($t('common.label.completed'))"/>
          </mdb-tabs>
          <div class="text-center">
            <mdb-btn icon="calendar-star"
                     @click="$router.push('/group/' + group.vanityPath + '/events')"> View All {{ capitalize($tc("common.label.event",2))  }}
            </mdb-btn>
          </div>
          <div class="text-center">
            <mdb-btn icon="calendar-plus"
                     @click="$router.push('/event/new/' + group.vanityPath )"
                     v-if="group.role == 'Admin' || group.role=='Event Organizer' || group.role=='Group Organizer'"
                     rounded size="sm">New {{ capitalize($tc("common.label.event",1))  }}
            </mdb-btn>
            <mdb-btn icon="lightbulb-on" @
                     rounded size="sm"
                     @click="$router.push('/event/suggest/' + group.vanityPath)"
                     v-if="group.role != 'Public' && group.allowSuggestions">{{ capitalize($tc("common.label.suggestion",2))  }}
            </mdb-btn>

            <mdb-btn icon="calendar"
                     v-if="group.role != 'Public'"
                     @click="$router.push('/group/' + group.vanityPath + '/calendar')" rounded size="sm">
              {{ capitalize($t("common.label.groupCalendar"))  }}
            </mdb-btn>

          </div>
        </mdb-card-body>
      </mdb-card>
    </div>

  </div>
</template>

<script>
import api from '../../services/groupsPlaceApi.js'
import eventList from '../event/List'
import error from '../common/Error'
import {mdbBtn, mdbCard, mdbCardBody, mdbCardHeader, mdbContainer, mdbIcon, mdbTabs} from 'mdbvue';

export default {
  name: 'imageSection',
  components: {
    mdbContainer,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbTabs,
    mdbIcon,
    mdbBtn,
    eventList,
    error
  },
  props: {
    group: {
      type: Object,
      default: null
    },
    eventData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      error: null
    };
  },
  computed: {
    settings() {
      return this.$store.state.settings
    }
  },
  mounted() {
    if (!this.group) {
      return
    }
  },
  methods: {
    loadEvents: function () {
      this.eventData = null
      api.get("/homepage/upcomingEventsSection/" + this.group.id + "?section=" + this.section, {}).then(
        (details) => {
          this.eventData = details.data
        },
        (error) => {
          this.error = error
        }
      ).then(() => {

      })
    }
  }
};
</script>
